import React from 'react';

function Missing(): JSX.Element {
  return <div>This page does not exist.</div>;
}

export default Missing;
